export default __webpack_public_path__ + "static/media/DecSelectedDataSortIcon.a835ed48.svg";